import Script from 'next/script'
import { useLogin } from '@/components/account/context/use-login'

export const KlaviyoTracking = () => {
  const { user } = useLogin()
  if (!user) {
    return null
  }
  return <Script src={`/load-Klaviyo.js`} />
}
